import { Vehicle } from '../../../../types/vehicle';
import NumberFormat from 'react-number-format';
import { useAdminOfferAuction } from '../hooks';
import { useOfferAuctionBidsInfo } from '../../../../hooks';
import styled from 'styled-components';
import { ButtonBase, Icon, Popover } from '@material-ui/core';
import { useState } from 'react';
import { ViewAllBidsTooltip } from '../../../Shared/VehicleDetails/components/BidHistorySection/components/ViewAllBidsModal';
import { convertToLocalTime } from '../../../../utils';
import { User } from 'types/user';
import { AUCTION_TYPES } from 'constants';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0px;
  font-weight: 500;
`;

const StyledBackButton = styled(ButtonBase)`
  margin-top: auto;
`;

type Props = {
  vehicle: Vehicle;
};

export const AdminAAOffers = ({ vehicle }: Props) => {
  const offerAuction = useAdminOfferAuction(vehicle.id);
  const { highestBidOffer } = useOfferAuctionBidsInfo(offerAuction);
  const proxyOfferBid = offerAuction?.offerProxyBid;

  return (
    <AdminOffers
      offers={offerAuction?.offerBids}
      highOffer={highestBidOffer || undefined}
      proxyOffer={proxyOfferBid}
      vehicleId={vehicle.id}
      type="offers"
    />
  );
};

export const AdminAlternativeOffers = ({ vehicle }: Props) => {
  const offers = vehicle.alternative_bid_offers;
  const highOffer = vehicle.top_alternative_bid_offer;

  const showMinBid = vehicle.auction && vehicle.auction.type === AUCTION_TYPES.SECOND_CHANCE;

  return (
    <AdminOffers
      showMinBid={showMinBid}
      minBid={vehicle.starting_bid}
      offers={offers}
      highOffer={highOffer}
      proxyOffer={highOffer}
      vehicleId={vehicle.id}
      type="alternativeOffers"
    />
  );
};

type SerializedOffer = {
  id: number;
  amount: number;
  bidder: User;
  created_at: string;
};

type GeneralProps = {
  offers?: SerializedOffer[];
  highOffer?: SerializedOffer;
  proxyOffer?: SerializedOffer;
  showMinBid?: boolean;
  minBid?: number;
  vehicleId: number;
  type: 'offers' | 'alternativeOffers';
};

export const AdminOffers = ({ vehicleId, offers, highOffer, proxyOffer, type, showMinBid, minBid }: GeneralProps) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenPopover = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const vehicleOfferBids = (offers || []).map(bid => ({
    id: bid.id,
    bid: bid.amount,
    bidder: bid.bidder?.dealership_name,
    date: convertToLocalTime(bid.created_at, true),
    created_at: bid.created_at,
    vehicle_id: vehicleId
  }));

  return (
    <Wrapper>
      {showMinBid && (
        <span style={{ color: '#666666', fontSize: '12px' }}>
          <NumberFormat displayType="text" prefix="$" value={minBid || 0} thousandSeparator />
        </span>
      )}
      <span style={{ fontWeight: 500 }}>
        <NumberFormat displayType="text" prefix="$" value={highOffer?.amount ?? 0} thousandSeparator />
      </span>

      {vehicleOfferBids.length > 0 && (
        <>
          <StyledBackButton onClick={handleOpenPopover}>
            <Icon>expand_more</Icon>
          </StyledBackButton>
          <Popover
            id="offer-history-popover"
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClosePopover}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            marginThreshold={150}
          >
            <ViewAllBidsTooltip
              bids={vehicleOfferBids}
              vehicleId={vehicleId}
              close={handleClosePopover}
              type={type}
              editable
              proxyBid={proxyOffer}
            />
          </Popover>
        </>
      )}
    </Wrapper>
  );
};
